import { Section } from '@factorialco/deprecated-design-system'
import {
  SettingPageAttendanceBalanceCarryoverFragment,
  TimeTrackingClockInPageQuery,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import BankOfHoursCounter from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/BankOfHoursCounter'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'
import type BalanceCarryover from 'modules/attendance/store/models/BalanceCarryover'

type AttendanceOvertimePool =
  TimeTrackingClockInPageQuery['attendance']['overtimePoolsConnection']['nodes'][number]

export interface Props {
  attendanceSetting: AttendanceSetting
  balanceCarryover?: SettingPageAttendanceBalanceCarryoverFragment
  setBalanceCarryover?: (balanceCarryover: BalanceCarryover) => void
  overtimePools: AttendanceOvertimePool[]
  hasBankOfHoursTransferFrequency: boolean
}

const CompensationMethods = ({
  attendanceSetting,
  balanceCarryover,
  overtimePools,
  hasBankOfHoursTransferFrequency,
}: Props) => {
  return (
    <>
      {hasBankOfHoursTransferFrequency && (
        <Section
          illustration="monety-bag"
          title={i18n.t('time_tracking.settings.compensation_methods.title')}
          description={i18n.t('time_tracking.settings.compensation_methods.description')}
        >
          <BankOfHoursCounter
            attendanceSetting={attendanceSetting}
            balanceCarryover={balanceCarryover}
            overtimePools={overtimePools}
          />
        </Section>
      )}
    </>
  )
}

export default observer(CompensationMethods)
